import { CommonObjectModel } from '../common';
import { PersonModel } from './person.model';
import { PersonMultModel } from '.';
import { PersonRelationModel } from './person-relation.model';
import { UserListingModel } from '../user/';

export class PersonEditModel extends PersonModel {
    DepartmentInfo: CommonObjectModel;
    ManagerInfo: UserListingModel;
    MaritalStatusInfo: CommonObjectModel;
    OriginContactInfo: CommonObjectModel;
    PreferredConfirmationInfo: CommonObjectModel;
    PreferredMediaInfo: CommonObjectModel;
    
    Mults: PersonMultModel[];
    Relations: PersonRelationModel[];

    /**
     *
     */
    constructor(option?: PersonEditModel) {
        super(option);

        this.Relations = [];
        this.Mults = [];
        
        if(option != null){
            this.Relations = option.Relations||[];
            this.Mults = option.Mults||[];
        }
        
    }
}